import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Loosely Tightened",
  date: new Date(2024, 8, 15),
  img: "/img/balcony.jpeg",
  video: "/videos/balcony.mp4",
  tracks: [
    {
      title: "Secrets In The Night",
      src: "/songs/2024-09-15/secrets_in_the_night.mp3",
      duration: 1103.712,
    },
    {
      title: "Lunch Money Bully",
      src: "/songs/2024-09-15/lunch_money_bully.mp3",
      duration: 1228.872,
    },
    {
      title: "The Very Hungry Caterpillar",
      src: "/songs/2024-09-15/the_very_hungry_caterpillar.mp3",
      duration: 1963.464,
    },
    {
      title: "Young And Restless",
      src: "/songs/2024-09-15/young_and_restless.mp3",
      duration: 1535.016,
    },
    {
      title: "Moonlit Balcony",
      src: "/songs/2024-09-15/moonlit_balcony.mp3",
      duration: 683.256,
    },
    {
      title: "Chasing OJ Down The Freeway",
      src: "/songs/2024-09-15/chasing_oj.mp3",
      duration: 609.768,
    },
    {
      title: "Saints Go Marching",
      src: "/songs/2024-09-15/saints_go_marching.mp3",
      duration: 719.448,
    },
    {
      title: "Rippin' Blues",
      src: "/songs/2024-09-15/rippin_blues.mp3",
      duration: 1074.144,
    },
  ],
};
export default album;
